export default function DottedSeparator({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="2"
      viewBox="0 0 999 1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>dotted line</title>
      <path
        d="M0 1H999"
        className="stroke-black-400"
        stroke-linejoin="round"
        stroke-dasharray="1 5"
      />
    </svg>
  );
}
